import React from 'react';

import { env } from '../config';

const PageErr = () => (
  <div
    className="py-5"
    style={{ backgroundColor: '#fff8db' }}
  >
    <div
      className="m-auto mw-100"
      style={{ width: '700px' }}
    >
      <img src={'assets/img/500-in.png'} className="mw-100" />
    </div>
  </div>
);

export default PageErr;
